(function () {
  "use strict";

  if (window.__MM_FOOTER_NEWSLETTER_NOTIFICATIONS_BOOTSTRAPPED__) {
    return;
  }
  window.__MM_FOOTER_NEWSLETTER_NOTIFICATIONS_BOOTSTRAPPED__ = true;

  const ROOT_SELECTOR = "[data-footer-newsletter-root]";
  const SESSION_KEY = "mrmaple.footerNewsletterIntent";
  const PREFILL_PARAM = "mm_prefill_email";
  const INTENT_PARAM = "mm_newsletter_intent";
  const INTENT_VALUE = "campaigns";
  const AUTH_STATUS_PATH = "/v1/notifications/account-status";
  const DATA_PATH = "/v1/notifications/data";
  const SECTIONS_PATH = "/v1/notifications/sections";
  const TOGGLE_PATH = "/v1/notifications/toggle";

  function normalizeString(value) {
    return typeof value === "string" ? value.trim() : "";
  }

  function normalizeApiBase(value) {
    const normalized = normalizeString(value);
    if (!normalized) return "/apps/garden";
    return normalized.replace(/\/+$/, "");
  }

  function showToast(message, type = "info", options = {}) {
    if (!message) return;
    if (typeof window.MMRestockToggleService?.showThemeToast === "function") {
      window.MMRestockToggleService.showThemeToast(message, type, options);
      return;
    }
    if (window.GardenToast?.show) {
      window.GardenToast.show(message, {
        type,
        actionLabel: options.linkText || "",
        onAction:
          options.linkHref
            ? () => {
                navigateTo(options.linkHref);
              }
            : null,
      });
      return;
    }
    console[type === "error" ? "error" : "log"](message);
  }

  async function parseJsonSafe(response) {
    try {
      const text = await response.text();
      if (!text) return {};
      return JSON.parse(text);
    } catch (_) {
      return {};
    }
  }

  function navigateTo(url) {
    if (typeof window.__MMFooterNewsletterNavigate === "function") {
      window.__MMFooterNewsletterNavigate(String(url || ""));
      return;
    }
    window.location.assign(url);
  }

  async function requestJson(root, path, options = {}) {
    const response = await fetch(`${normalizeApiBase(root.dataset.appProxyBase)}${path}`, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...(options.headers || {}),
      },
      ...options,
    });

    const data = await parseJsonSafe(response);
    if (!response.ok) {
      const message =
        normalizeString(data?.error) ||
        normalizeString(data?.message) ||
        "Request failed. Please try again.";
      const error = new Error(message);
      error.status = response.status;
      error.payload = data;
      throw error;
    }

    return data;
  }

  function getRoots() {
    return Array.from(document.querySelectorAll(ROOT_SELECTOR));
  }

  function getLoggedInCustomerId(root) {
    return (
      normalizeString(root?.dataset.customerId) ||
      normalizeString(window.ShopifyCustomer?.id) ||
      normalizeString(window.Shopify?.customer?.id)
    );
  }

  function isLoggedIn(root) {
    return Boolean(getLoggedInCustomerId(root));
  }

  function getSharedGardenCache() {
    return window.MrMapleGardenCache || null;
  }

  function getGardenCacheOptions(root) {
    return {
      shop:
        normalizeString(root?.dataset.shop) ||
        normalizeString(window.Shopify?.shop) ||
        normalizeString(window.Shopify?.shopDomain) ||
        undefined,
      customerId: getLoggedInCustomerId(root) || undefined,
    };
  }

  function readCachedNotificationsData(root) {
    const cache = getSharedGardenCache();
    if (!cache?.peek) {
      return null;
    }

    const cacheOptions = getGardenCacheOptions(root);
    const entry = cache.peek("notifications", cacheOptions);
    if (!entry?.data) {
      return null;
    }

    if (
      typeof cache.isFresh === "function" &&
      !cache.isFresh("notifications", entry, cacheOptions)
    ) {
      return null;
    }

    return entry.data;
  }

  async function invalidateNotificationsCache(root) {
    const cache = getSharedGardenCache();
    if (!cache?.invalidateTags) {
      return;
    }

    try {
      await cache.invalidateTags(["notifications"], getGardenCacheOptions(root));
    } catch (error) {
      console.warn("[Footer Newsletter] Failed to invalidate notifications cache.", error);
    }
  }

  function getStatusElement(root) {
    return root.querySelector('[data-role="status"]');
  }

  function setInlineStatus(root, message = "", state = "") {
    const status = getStatusElement(root);
    if (!(status instanceof HTMLElement)) return;
    status.textContent = message;
    status.dataset.state = state || "";
    status.hidden = !message;
  }

  function getField(root, selector) {
    return root.querySelector(selector);
  }

  function setPending(root, isPending) {
    root.dataset.pending = isPending ? "true" : "false";
    const buttons = root.querySelectorAll("button");
    buttons.forEach((button) => {
      button.disabled = isPending;
      button.setAttribute("aria-busy", isPending ? "true" : "false");
    });
  }

  function showGuestState(root) {
    root.dataset.state = "guest";
    const block = root.closest(".site-footer-block-item");
    if (block instanceof HTMLElement) {
      block.hidden = false;
      block.removeAttribute("aria-hidden");
    }
    const guestForm = getField(root, '[data-role="guest-form"]');
    const buttonRow = getField(root, '[data-role="button-row"]');
    if (guestForm instanceof HTMLElement) guestForm.hidden = false;
    if (buttonRow instanceof HTMLElement) buttonRow.hidden = true;
  }

  function showButtonState(root) {
    root.dataset.state = "button";
    const block = root.closest(".site-footer-block-item");
    if (block instanceof HTMLElement) {
      block.hidden = false;
      block.removeAttribute("aria-hidden");
    }
    const guestForm = getField(root, '[data-role="guest-form"]');
    const buttonRow = getField(root, '[data-role="button-row"]');
    if (guestForm instanceof HTMLElement) guestForm.hidden = true;
    if (buttonRow instanceof HTMLElement) buttonRow.hidden = false;
  }

  function hideWidget(root) {
    root.dataset.state = "hidden";
    const block = root.closest(".site-footer-block-item");
    if (block instanceof HTMLElement) {
      block.hidden = true;
      block.setAttribute("aria-hidden", "true");
    } else {
      root.hidden = true;
    }
  }

  function getPrefillEmailFromUrl() {
    try {
      return normalizeString(new URL(window.location.href).searchParams.get(PREFILL_PARAM));
    } catch (_) {
      return "";
    }
  }

  function getPendingIntentFromStorage() {
    try {
      const raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (normalizeString(parsed?.intent) !== INTENT_VALUE) return null;
      return {
        intent: INTENT_VALUE,
        email: normalizeString(parsed?.email),
      };
    } catch (_) {
      return null;
    }
  }

  function getPendingIntentFromUrl() {
    try {
      const url = new URL(window.location.href);
      if (normalizeString(url.searchParams.get(INTENT_PARAM)) !== INTENT_VALUE) {
        return null;
      }
      return {
        intent: INTENT_VALUE,
        email: normalizeString(url.searchParams.get(PREFILL_PARAM)),
      };
    } catch (_) {
      return null;
    }
  }

  function getPendingIntent() {
    return getPendingIntentFromStorage() || getPendingIntentFromUrl();
  }

  function setPendingIntent(email) {
    try {
      sessionStorage.setItem(
        SESSION_KEY,
        JSON.stringify({
          intent: INTENT_VALUE,
          email: normalizeString(email),
          createdAt: Date.now(),
        }),
      );
    } catch (_) {}
  }

  function clearPendingIntent() {
    try {
      sessionStorage.removeItem(SESSION_KEY);
    } catch (_) {}
  }

  function clearIntentParamsFromUrl() {
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has(INTENT_PARAM) && !url.searchParams.has(PREFILL_PARAM)) {
        return;
      }
      url.searchParams.delete(INTENT_PARAM);
      url.searchParams.delete(PREFILL_PARAM);
      const nextUrl = `${url.pathname}${url.search}${url.hash}`;
      window.history.replaceState({}, document.title, nextUrl);
    } catch (_) {}
  }

  function prefillAuthForms() {
    const email = getPrefillEmailFromUrl() || normalizeString(getPendingIntentFromStorage()?.email);
    if (!email) return;

    const loginEmail = document.getElementById("customer_email");
    if (loginEmail instanceof HTMLInputElement && !normalizeString(loginEmail.value)) {
      loginEmail.value = email;
      loginEmail.dispatchEvent(new Event("input", { bubbles: true }));
      loginEmail.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const registerEmail = document.getElementById("register_email");
    if (registerEmail instanceof HTMLInputElement && !normalizeString(registerEmail.value)) {
      registerEmail.value = email;
      registerEmail.dispatchEvent(new Event("input", { bubbles: true }));
      registerEmail.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function getCampaignSection(payload) {
    if (Array.isArray(payload?.sections)) {
      return payload.sections.find((section) => normalizeString(section?.key) === INTENT_VALUE) || null;
    }

    const campaigns = Array.isArray(payload?.campaigns) ? payload.campaigns : [];
    return {
      key: INTENT_VALUE,
      enabled: true,
      items: campaigns.filter((item) => item?.isSubscribed),
      catalog: campaigns.map((item) => ({
        ...item,
        selected: item?.selected ?? item?.isSubscribed === true,
      })),
    };
  }

  function getCampaignId(item) {
    if (typeof item?.campaignId === "number" && Number.isFinite(item.campaignId)) {
      return String(item.campaignId);
    }
    if (typeof item?.campaignId === "string" && item.campaignId.trim()) {
      return item.campaignId.trim();
    }
    if (typeof item?.id === "number" && Number.isFinite(item.id)) {
      return String(item.id);
    }
    return normalizeString(item?.id);
  }

  function getCampaignSubscriptionState(payload) {
    const section = getCampaignSection(payload);
    if (!section) {
      return {
        hasCatalog: false,
        enabled: false,
        missingIds: [],
        fullySubscribed: false,
      };
    }

    const items = Array.isArray(section.items) ? section.items : [];
    const catalog = Array.isArray(section.catalog) ? section.catalog : [];
    const selectedIds = new Set(items.map(getCampaignId).filter(Boolean));

    const catalogIds = catalog.map(getCampaignId).filter(Boolean);
    const missingIds = catalog
      .filter((item) => {
        const campaignId = getCampaignId(item);
        if (!campaignId) return false;
        if (item?.selected === true || item?.isSubscribed === true) return false;
        return !selectedIds.has(campaignId);
      })
      .map(getCampaignId)
      .filter(Boolean);

    const enabled = section.enabled !== false;
    const hasCatalog = catalogIds.length > 0;

    return {
      hasCatalog,
      enabled,
      missingIds,
      fullySubscribed: hasCatalog && enabled && missingIds.length === 0,
    };
  }

  async function fetchNotificationsData(root, options = {}) {
    const suffix = options.refresh ? `${DATA_PATH}?refresh=1` : DATA_PATH;
    const cache = getSharedGardenCache();
    if (!cache?.query) {
      return requestJson(root, suffix, { method: "GET" });
    }

    const result = await cache.query(
      {
        module: "notifications",
        domain: "notifications",
        revisionDomain: "notifications",
        tags: ["notifications"],
        refresh: options.refresh === true,
        background: false,
        fetcher: async ({ headers = {} } = {}) => {
          const response = await fetch(
            `${normalizeApiBase(root.dataset.appProxyBase)}${suffix}`,
            {
              credentials: "same-origin",
              cache: options.refresh ? "no-store" : "default",
              headers: {
                Accept: "application/json",
                ...headers,
              },
              method: "GET",
            },
          );

          if (!response.ok && response.status !== 304) {
            const data = await parseJsonSafe(response.clone());
            const message =
              normalizeString(data?.error) ||
              normalizeString(data?.message) ||
              "Request failed. Please try again.";
            const error = new Error(message);
            error.status = response.status;
            error.payload = data;
            throw error;
          }

          return response;
        },
      },
      getGardenCacheOptions(root),
    );

    return result?.data || {};
  }

  async function unmuteCampaignsSection(root) {
    return requestJson(root, SECTIONS_PATH, {
      method: "POST",
      body: JSON.stringify({
        action: "unmute",
        section: INTENT_VALUE,
      }),
    });
  }

  async function subscribeCampaign(root, campaignId) {
    return requestJson(root, TOGGLE_PATH, {
      method: "POST",
      body: JSON.stringify({
        type: "campaign",
        campaignId,
      }),
    });
  }

  function buildReturnUrl(email) {
    const url = new URL(window.location.href);
    url.searchParams.set(INTENT_PARAM, INTENT_VALUE);
    url.searchParams.set(PREFILL_PARAM, email);
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function buildAuthUrl(root, type, email) {
    const attr =
      type === "login"
        ? root.dataset.accountLoginUrl
        : root.dataset.accountRegisterUrl;
    const url = new URL(normalizeString(attr) || (type === "login" ? "/account/login" : "/account/register"), window.location.origin);
    url.searchParams.set(PREFILL_PARAM, email);
    url.searchParams.set("return_url", buildReturnUrl(email));
    return `${url.pathname}${url.search}${url.hash}`;
  }

  async function routeGuestToAuth(root, email) {
    const data = await requestJson(root, AUTH_STATUS_PATH, {
      method: "POST",
      body: JSON.stringify({ email }),
    });

    const redirectUrl = buildAuthUrl(root, data?.exists ? "login" : "register", email);
    setPendingIntent(email);
    navigateTo(redirectUrl);
  }

  async function applyLoggedInState(root, options = {}) {
    const payload =
      options.network === false
        ? readCachedNotificationsData(root)
        : await fetchNotificationsData(root, options);

    if (!payload) {
      showButtonState(root);
      return {
        deferred: true,
      };
    }

    const state = getCampaignSubscriptionState(payload);

    if (!state.hasCatalog || state.fullySubscribed) {
      hideWidget(root);
      return state;
    }

    showButtonState(root);
    return state;
  }

  async function subscribeAllCampaigns(root, options = {}) {
    const notificationsUrl =
      normalizeString(root.dataset.accountNotificationsUrl) || "/account?tab=notifications";

    setPending(root, true);
    setInlineStatus(root, "", "");

    try {
      let payload = await fetchNotificationsData(root, { refresh: options.refresh === true });
      let state = getCampaignSubscriptionState(payload);
      let mutated = false;

      if (!state.hasCatalog) {
        hideWidget(root);
        clearPendingIntent();
        clearIntentParamsFromUrl();
        return state;
      }

      if (!state.enabled) {
        await unmuteCampaignsSection(root);
        mutated = true;
      }

      for (const campaignId of state.missingIds) {
        await subscribeCampaign(root, campaignId);
        mutated = true;
      }

      if (mutated) {
        await invalidateNotificationsCache(root);
      }

      payload = await fetchNotificationsData(root, { refresh: true });
      state = getCampaignSubscriptionState(payload);

      if (state.fullySubscribed || !state.hasCatalog) {
        hideWidget(root);
      } else {
        showButtonState(root);
      }

      clearPendingIntent();
      clearIntentParamsFromUrl();

      if (!options.silentSuccess) {
        showToast("Newsletter alerts saved.", "success", {
          linkText: "Manage alerts",
          linkHref: notificationsUrl,
        });
      }

      return state;
    } catch (error) {
      showButtonState(root);
      const message =
        error instanceof Error ? error.message : "Unable to save newsletter alerts.";
      setInlineStatus(root, message, "error");
      if (!options.silentError) {
        showToast(message, "error");
      }
      throw error;
    } finally {
      setPending(root, false);
    }
  }

  async function handlePendingIntent(root) {
    const intent = getPendingIntent();
    if (!intent || normalizeString(intent.intent) !== INTENT_VALUE) {
      return false;
    }
    if (!isLoggedIn(root)) {
      return false;
    }

    await subscribeAllCampaigns(root, {
      refresh: true,
      silentSuccess: false,
      silentError: false,
    });
    return true;
  }

  function attachGuestSubmit(root) {
    const form = getField(root, '[data-role="guest-form"]');
    const emailInput = form?.querySelector('input[type="email"]');
    if (!(form instanceof HTMLFormElement) || !(emailInput instanceof HTMLInputElement)) {
      return;
    }

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const email = normalizeString(emailInput.value);

      if (!emailInput.checkValidity() || !email) {
        setInlineStatus(root, "Enter a valid email address.", "error");
        return;
      }

      setPending(root, true);
      setInlineStatus(root, "", "");

      try {
        await routeGuestToAuth(root, email);
      } catch (error) {
        setPending(root, false);
        const message =
          error instanceof Error ? error.message : "Unable to start newsletter signup.";
        setInlineStatus(root, message, "error");
        showToast(message, "error");
      }
    });
  }

  function attachLoggedInButton(root) {
    const button = getField(root, '[data-role="subscribe-button"]');
    if (!(button instanceof HTMLButtonElement)) {
      return;
    }

    button.addEventListener("click", async (event) => {
      event.preventDefault();
      if (!isLoggedIn(root)) {
        showGuestState(root);
        return;
      }
      await subscribeAllCampaigns(root, { refresh: true });
    });
  }

  async function initializeRoot(root) {
    if (!(root instanceof HTMLElement) || root.dataset.footerNewsletterInitialized === "true") {
      return;
    }

    root.dataset.footerNewsletterInitialized = "true";
    attachGuestSubmit(root);
    attachLoggedInButton(root);

    if (!isLoggedIn(root)) {
      showGuestState(root);
      return;
    }

    const consumedIntent = await handlePendingIntent(root).catch(() => false);
    if (consumedIntent) {
      return;
    }

    try {
      await applyLoggedInState(root, { network: false });
    } catch (error) {
      showButtonState(root);
      setInlineStatus(
        root,
        error instanceof Error ? error.message : "Unable to load newsletter settings.",
        "error",
      );
    }
  }

  function initializeAll() {
    prefillAuthForms();
    getRoots().forEach((root) => {
      void initializeRoot(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", initializeAll);
})();
